import React, { useCallback, useState, useEffect } from 'react';
import loadable from '@loadable/component';

import { Modal, Button, Counter, Typography } from '@hpstellar/core';
import { Cross, ArrowRight } from '@hpstellar/icons';

import { Helpers } from '../../core/src/helpers';

import './filter-modal.less';

const OrionMobileFilterHeader = loadable(() => Helpers.retryFunc(() => import('./orion/orion-mobile-filter-header')));
const OrionMobileFilterFooter = loadable(() => Helpers.retryFunc(() => import('./orion/orion-mobile-filter-footer')));

export default function FilterModal({
    children,
    isOpen,
    onModalClose,
    filterCount,
    resultsCount,
    clearFilters,
    className,
    visId,
    hidden,
    vwaVariant = false,
    orionEnabled = false,
}) {
    const [openAnim, setOpenAnim] = useState(false);

    const handleModalClose = useCallback(() => {
        setTimeout(() => {
            onModalClose();
            setOpenAnim(false);
        }, 0);
    }, [onModalClose]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenAnim(isOpen);
        }, 10);
        return () => clearTimeout(timer);
    }, [isOpen]);

    return (
        <Modal
            aria-describedby="modal_description"
            aria-labelledby="modal_title"
            backdropClassName={orionEnabled ? 'modalFilterBackdrop-orion' : null}
            modalClassName={
                `modalFilterContainer` +
                (vwaVariant ? ' modalFilterContainer-VWA' : '') +
                (orionEnabled ? ' modalFilterContainer-orion' : '')
            }
            onModalClose={handleModalClose}
            isOpen={isOpen}
            className={className}
            style={hidden ? { display: 'none' } : {}}
            withBackdrop={vwaVariant}
        >
            <div className={`modalFilterContent${openAnim ? ' open' : ''}`}>
                {orionEnabled ? (
                    <OrionMobileFilterHeader onModalClose={handleModalClose} />
                ) : (
                    <div className="filterHeader">
                        {vwaVariant && <Typography variant="titleS">Sort & Filter</Typography>}

                        {['string', 'number'].includes(typeof filterCount) && (
                            <Counter className="counter" count={filterCount} size="large" subsetDelimiter="of">
                                {`Filter${filterCount === 1 ? '' : 's'} Applied`}
                            </Counter>
                        )}
                        <button type="button" className="close" onClick={handleModalClose}>
                            <Cross size="xs" />
                        </button>
                    </div>
                )}
                <div className="filterContent">{children}</div>
                <div className="filterFooter">
                    {orionEnabled ? (
                        <OrionMobileFilterFooter
                            clearFilters={clearFilters}
                            resultsCount={resultsCount}
                            onModalClose={handleModalClose}
                        />
                    ) : (
                        <>
                            {clearFilters && (
                                <span className="clear">
                                    <Button
                                        className="button"
                                        variation="tertiary"
                                        color={visId ? 'dark' : 'primary'}
                                        onClick={clearFilters}
                                    >
                                        CLEAR ALL
                                    </Button>
                                </span>
                            )}
                            <span className={`show${visId ? ' visId' : ''}`}>
                                <Button
                                    className="button"
                                    color={visId ? 'dark' : 'primary'}
                                    endIcon={<ArrowRight size="s" />}
                                    onClick={handleModalClose}
                                >
                                    {`SHOW ${resultsCount} RESULT${resultsCount > 1 ? 'S' : ''}`}
                                </Button>
                            </span>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
}
